import {SEND_MESSAGE, SET_CHATROOM_TITLE, SET_CHATROOM_MEMBERS, SET_CHATROOM_MESSAGES, SET_ME} from '../actions/types';

const initialState = {
    chatRoomName: 'Chat room',
    me: {
        is_online: true,
        uuid: "98s7dfh9a8s7dhf"
    },
    messages: [],
    members: [],

}

const Chat = (state = initialState, action) => {
    switch(action.type) {
        case SEND_MESSAGE: {
          const currentMessages = state.messages;
          currentMessages.push(action.payload);
          const newStateFragment = {messages: currentMessages};
          return {
            ...state,
            ...newStateFragment
          }
        }
        case SET_CHATROOM_TITLE: {
          return {
            ...state,
            chatRoomName: action.payload
          }
        }
        case SET_CHATROOM_MEMBERS: {
          return {
            ...state,
            ...action.payload
          }
        }
        case SET_CHATROOM_MESSAGES: {
          // const currentMessages = state.messages;
          // currentMessages.push(receivedMsg);
          // const newStateFragment = {messages: currentMessages};

          return {
            ...state,
            messages: [...action.payload]
          }
        }
        case SET_ME: {
          return {
            ...state,
          }
        }


        default: return state;
    }
}

export default Chat;